// Import all language .json files in the current folder
const ctx = require.context("./", false, /\.json$/);

const languages = {};

ctx.keys().forEach(key => {
  const code = key.replace("./", "").replace(".json", "");
  languages[code] = ctx(key);
});

export { languages };

export const supportedLanguages = Object.keys(languages);

// Override for flags not matching filename
const FLAG_OVERRIDES = {
  "zh-Hans": "CN",
  ar: "SA",
  en: "GB",
  ja: "JP",
  ur: "PK"
};

function inferFlagCode(lang) {
  // Use flag override if exists for current lang
  if (FLAG_OVERRIDES[lang]) return FLAG_OVERRIDES[lang];

  const parts = lang.split(/[-_]/);

  // Use filename suffix for flag code if exists
  if (parts[1] && parts[1].length >= 2) return parts[1].toUpperCase();

  // Use filename for flag
  return parts[0].slice(0, 2).toUpperCase();
}

export const languageOptions = supportedLanguages.map(value => ({
  value,
  code: inferFlagCode(value)
}));
